import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useCachedFetch } from '@/composables/useFetch';
import { useSessionStore } from '@/stores/SessionStore'

import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $BASEURL } = useConfigurationGlobals()

export let useOnsiteReportsStore = defineStore('onsiteReportStore', () => {
  const sessionStore = useSessionStore();

  const onsiteReportsData = ref(null);

  const onsiteReports = computed(() => onsiteReportsData.value.onsite_reports || [])
  const hasOnsiteReports = computed(() => onsiteReportsData.value && onsiteReports.value.length > 0)

  async function getOnsiteReports(lat, lon) {
    const settings = {
      time_start_offset_minutes: 1440,
      report_type: 'human',
      distance_mi: 19,
      day_offset: null,     
      lat,
      lon,
      wf_token: sessionStore.token,
    }

    const queryString = new URLSearchParams(settings).toString()
    const url = `${$BASEURL}/report/getOnsiteReportSet?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      onsiteReportsData.value = data.value;

      return data.value;
    } catch (error) {
      console.warn(error)

      return error
    }
  }

  return {
    onsiteReportsData,
    onsiteReports,
    hasOnsiteReports,
    getOnsiteReports
  }
})
